    'use strict';

    // Declare app level module which depends on views, and components
     var myApp =   angular.module('myApp', ['ngRoute', 'myApp.blue', 'ngMaterial']);
     var App = angular.module('myApp.blue', ['ngRoute']);
     var responseStatus = {
         SUCCESS: 143,
         LOGIN_SUCCESS: 407,
         REGISTER_SUCCESS: 701,
         SESSION_EXPIRED: 101

     }

    myApp.constant('documentsList', {
        MANDATORY: 1,
        REQUIRED: 3,
        COMPULSORY: 4

    })

    myApp.directive('fileModel', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function(){
                    scope.$apply(function(){
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }]);

    //myApp.config(['$routeProvider','$locationProvider', function($routeProvider,$locationProvider) {
    //
    //
    //
    //     }])

    myApp.filter('camelCase', function() {
        return function(input) {
            return input.charAt(0).toUpperCase() +   input.substr(1).toLowerCase();
        }
     })

    myApp.filter('documentsColorFilter', function() {
        return function(input) {
            switch(input){
                case 1:  return "#f57300" ;break;
                case 2:  return "#ff001f" ;break;
                case 3:  return "#099f3c";break;
                case 4:  return "#099f3c";break;
            }

        }
    })
    myApp.filter('documentsFilter', function() {
        return function(input) {
            switch(input){
                case 1:  return "Approval Pending" ;break;
                case 2:  return "Rejected" ;break;
                case 3:  return "Verified";break;
                case 4:  return "Uploaded";break;
            }

        }
    })

    myApp.run(function() {



    })


     // main controller for whole app
    myApp.controller('MainController',['$rootScope','$scope','driverService','$location' ,function ($rootScope,$scope,driverService,$location) {
        $rootScope.tasks = [];
        $rootScope.loading_custom = false;
        $rootScope.showLogout = localStorage.getItem('loginData') ? true : false;

        $rootScope.openOtpModal = function (){
            $rootScope.showOtpScreen = false;
            document.getElementById('phoneNumber').value = "";
            document.getElementById('loginOTP').value = "";

            $('#login').modal('show');
            $("#phoneNumber").intlTelInput({
                utilsScript:'/bower_components/intl-tel-input/build/js/utils.js',
                initialCountry:"CA"
            })
        }

        $rootScope.logoutDriver = function(){
            localStorage.removeItem('access_token');
            localStorage.removeItem('loginData');
            $rootScope.showLogout = false;
            $location.path('/')
        }

        $rootScope.generateDriverOtp = function(resend_text){

            $scope.loginPhoneNo = $('#phoneNumber').intlTelInput("getNumber");
            localStorage.setItem('loginPhoneNumber',$scope.signupPhoneNo);
            var country_code =  $("#phoneNumber").intlTelInput("getSelectedCountryData").dialCode;
            localStorage.setItem('signUpCountryCode',country_code)
            if(!$scope.loginPhoneNo || !country_code || !($('#phoneNumber').intlTelInput("isValidNumber")))
            {
                $scope.error_message = 'Please enter valid phone no'
                return;
            }
            else {
                var reqObj = {
                    phone_no:  $scope.loginPhoneNo,
                    country_code: country_code,
                    os_version: '',
                    device_name: '',
                    device_token: ''

                }
                driverService.generateOtp(reqObj).then(function(res){
                    if(res.data.flag == responseStatus.SUCCESS){
                        $scope.error_message = '';
                        $scope.lastFourDigits =  $scope.loginPhoneNo.replace(/.(?=.{4,}$)/g, '*');
                        $rootScope.showOtpScreen = true;
                        if(resend_text)
                            $scope.otperror = res.data.message;
                        //localStorage.removeItem('currentTab');
                        //localStorage.removeItem('nextTab');
                        //localStorage.removeItem('currentTaskBar');
                        //localStorage.removeItem('access_token');

                        //localStorage.setItem('currentTab',null);
                        //localStorage.setItem('currentTaskBar',null);
                        //$location.path('/details')
                    }
                    else{
                        $scope.error_message = res.data.message;
                    }

                })
                $scope.otp = '';
                $scope.otperror = '';

                //  $location.path('/driver');
            }
        }

        $scope.verifyLoginOTP = function(otp) {
            if(otp) {
                var reqObj = {
                    phone_no:  $scope.loginPhoneNo,
                    login_otp: otp
                }

                driverService.verifyOtp(reqObj).then(function(res){
                    if(res.data.flag == responseStatus.LOGIN_SUCCESS){
                        localStorage.setItem('access_token', res.data.access_token);
                        localStorage.setItem('loginData',JSON.stringify(res.data.login));
                        $rootScope.showLogout = true;
                        $('#login').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        $location.path('/profile');

                    }
                        else if(res.data.flag == responseStatus.REGISTER_SUCCESS){

                        $scope.otperror = "You are not registered with us. Please register";
                    }
                    else {
                        $scope.otperror = res.data.error;
                    }
                })
            }
            else{
                $scope.otperror = "Please enter 4-digit OTP";
            }
        }

    }])


    myApp.directive('ngEnter', function () { //a directive to 'enter key press' in elements with the "ng-enter" attribute

            return function (scope, element, attrs) {

                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngEnter);
                        });

                        event.preventDefault();
                    }
                });
            };
        })


    myApp.config(['$locationProvider', '$routeProvider', '$mdThemingProvider' , function($locationProvider,$routeProvider,$mdThemingProvider) {


        $locationProvider.html5Mode(false);
        $locationProvider.hashPrefix('!');

        $routeProvider.when('/login', {
            templateUrl: 'components/homepage/merchantLogin.html',
            controller: 'merchantLoginCtrl'
        })
        $routeProvider.when('/', {
            templateUrl: 'components/homepage/shapHomepage.html',
            controller: 'homepageController'
        })
        $routeProvider.when('/details', {
            templateUrl: 'components/addDriver/addDriver.html',
            controller: 'addDriverController'
        })
        $routeProvider.when('/vehicle', {
            templateUrl: 'components/addVehicle/addVehicle.html',
            controller: 'addVehicleController'
        })
        $routeProvider.when('/documents', {
            templateUrl: 'components/documents/documents.html',
            controller: 'documentsController'
        })
        $routeProvider.when('/profile', {
            templateUrl: 'components/driverProfile/driverProfile.html',
            controller: 'documentsController'
        })

        $routeProvider.when('/terms', {
            templateUrl: 'components/terms-conditions/terms.html',
            controller: 'termsAndConditions'
        })

        $routeProvider.when('/privacy-policy', {
            templateUrl: 'components/terms-conditions/privacy.html',
            controller: 'termsAndConditions'
        })



        $routeProvider.otherwise({ redirectTo: '/404' })

    }]);



